import { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import classNames from 'classnames';

import premiumIcon from '@assets/Images/premium.png';
import Loader from '@components/loaders/loader';
import PremiumOverviewScreen from '@components/premium-screens/premium-overview/PremiumOverviewScreen';
import PremiumStatusScreen from '@components/premium-screens/premium-status/PremiumStatusScreen';
import PremiumSuspendedScreen from '@components/premium-screens/premium-suspended/PremiumSuspendedScreen';
import useGetProfile from '@hooks/profile/useGetProfile';
import { useAppSelector } from '@hooks/redux/useRedux';

import './premiumBadge.scss';

const selection = createSelector(
    (state) => state.profileReducer,
    (profile) => ({
        isPremium: profile.data?.premium ?? false,
        isSuspended: profile.data?.suspended ?? false,
        premiumAt: profile.data?.premiumAt ?? null,
        isLoading: profile.dataIsLoading ?? false,
    }),
);

const PremiumBadge = ({
    showBadge = true,
    shouldShow = false,
    onClose = () => null,
}) => {
    const [shouldShowPopup, setShouldShowPopup] = useState(false);
    const [shouldFetchProfileData, setShouldFetchProfileData] = useState(false);

    useEffect(() => setShouldShowPopup(shouldShow), [shouldShow]);

    useGetProfile({
        shouldFetch: shouldFetchProfileData,
        ignoreRefetch: !shouldFetchProfileData,
    });

    const { isPremium, isSuspended, premiumAt, isLoading } =
        useAppSelector(selection);

    const open = () => setShouldShowPopup(true);

    const close = () => {
        setShouldShowPopup(false);
        onClose?.();
    };

    return (
        <>
            {showBadge && (
                <div
                    className={classNames('premium-badge', {
                        isPremium: isPremium && !isSuspended,
                    })}
                    onClick={isLoading ? null : open}
                >
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <img src={premiumIcon} alt="premium-icon" />
                    )}
                </div>
            )}

            {!isPremium && (
                <PremiumOverviewScreen
                    shouldShow={shouldShowPopup}
                    onClose={close}
                    onSuccess={() => setShouldFetchProfileData(true)}
                />
            )}
            {isPremium && !isSuspended && (
                <PremiumStatusScreen
                    premiumSince={premiumAt}
                    shouldShow={shouldShowPopup}
                    onClose={close}
                />
            )}
            {isPremium && isSuspended && (
                <PremiumSuspendedScreen
                    premiumSince={premiumAt}
                    shouldShow={shouldShowPopup}
                    onClose={close}
                />
            )}
        </>
    );
};

export default PremiumBadge;
